import { useState } from 'react';
import axios from 'axios';
import notify, { MESSAGES } from '../../../utils/notify';
import { api } from '../../../config';
import { getAuthToken } from '../../../auth/tokenvalidation';
import { updateTenderOpeningStatus } from './useUpdateTenderOpeningStatus';
import {
  buildParcelFreightExportRows,
  downloadParcelFreightExcel,
} from '../utils/parcelFreightHelpers';

const useFreightRequest = ({
  procurementId,
  procurement,
  onRefreshProcurement,
}) => {
  const [isSubmitting, setIsSubmitting] = useState(false);
  const [isExportingExcel, setIsExportingExcel] = useState(false);

  const sendFreightRequest = async () => {
    const token = getAuthToken();
    if (!token) {
      notify.error(MESSAGES.authRequired);
      return false;
    }

    setIsSubmitting(true);
    try {
      await axios.put(
        `${api.API_URL}/procurement/send-request-freight-availability/${procurementId}`,
        {},
        {
          headers: {
            'Content-Type': 'application/json',
            Authorization: `Bearer ${token}`,
          },
        }
      );

      await updateTenderOpeningStatus(
        procurementId,
        'isReqFreightAvailabilityCompleted'
      );

      notify.success('Freight availability request sent successfully.');
      onRefreshProcurement?.();
      return true;
    } catch (err) {
      notify.apiError(err, 'send freight availability request');
      return false;
    } finally {
      setIsSubmitting(false);
    }
  };

  const exportParcelFreightToExcel = parcels => {
    const rows = buildParcelFreightExportRows(parcels);
    if (!rows.length) {
      notify.info(
        'No cargo combines FOB with CFR, DAP or CIF, so there is nothing to export.'
      );
      return false;
    }

    setIsExportingExcel(true);
    try {
      downloadParcelFreightExcel(rows, {
        procurementNumber: procurement?.procurementNumber,
        submittedDate: procurement?.submittedDateTenderOpening,
      });
      return true;
    } catch (error) {
      notify.apiError(error, 'export parcel data to Excel');
      return false;
    } finally {
      setIsExportingExcel(false);
    }
  };

  return {
    isSubmitting,
    sendFreightRequest,
    exportParcelFreightToExcel,
    isExportingExcel,
  };
};

export default useFreightRequest;
